import WRAP from "WRAP-JS";
import moment from "moment";
import { convertWRAPPoint } from "../../../utils/FPEUtils";

/* eslint-disable */
WRAP.Renderer.PointInfoExt = function() {
    WRAP.Renderer.call(this);
    var renderer = this;
    
    function _rotate(offset, rotation){
        var r = Math.PI*rotation/180.0;
        return [offset*Math.sin(r), -offset*Math.cos(r)];
    }

    function _getLabelMetrics(text, font_size, padding) {
        var m = {w:0, h:padding.top};
        for ( var i = 0 ; i < text.length ; i++ ) {
            var tm = WRAP.Geo.getTextMetrics(text[i], font_size);
            if ( m.w < tm[0] )
                m.w = tm[0];
            m.h += padding.line + tm[1];
        }
        m.w += padding.left+padding.right;
        return m;
    }

    function _mapping(locale, text, prop, cs, key) {
        if ( !prop )
            return text;
        if (text.indexOf('%LNAME%') >= 0) {
            if ( locale == 'en' && prop.ENAME )
                text = text.replace('%LNAME%', prop.ENAME);
        }
        if (text.indexOf('%valid_time%') >= 0 && prop.valid_time) {
            var format = 'YYYY/MM/DD HH:MM';
            if (cs.valid_time && cs.valid_time[locale])
                format = cs.valid_time[locale];
            var vt = new WRAP.Core.DateTime(prop.valid_time);
            var vt_text = vt.text(format);
            try {
                moment;
                vt_text = vt.format(format, WRAP.Core.timezone);
            }
            catch (err) {
                vt_text = vt.text(format);
            }
            return text.replace('%valid_time%', vt_text);
        }
        if ( text && text.indexOf('%') >= 0 ) {
            for ( var k in prop ) {
                if ( k == locale ) {
                    var kw = '%'+key+'%';
                    if ( text.indexOf(kw) >= 0 )
                        return text.replace(kw, prop[k]);
                }
                if ( typeof (prop[k]) == 'object' ) {
                    var kw = '';
                    if ( key )
                        kw += key+'.';
                    kw += k;
                    text = _mapping(locale, text, prop[k], cs, kw);
                }
                else {
                    var kw = '%';
                    if ( key )
                        kw += key+'.';
                    kw += k+'%';
                    if ( text.indexOf(kw) >= 0 )
                        text = text.replace(kw, prop[k]);
                }
            }
        }
        return text;
    }

    function _addLabels(labels, mask, points, ls, cs, locale, font_size, px, py, pw, ph, padding, margin, position, min_width, priority) {
        for ( var i = 0 ; i < points.length ; i++ ) {
            var item = points[i];
            var prop = item.properties;
            if ((prop.prioritized && !priority) || (!prop.prioritized && priority))
                continue;
            var text = [];
            for ( var j = 0 ; j < ls.text_lines.length ; j++ ) {
                var row = _mapping(locale, ls.text_lines[j], prop, cs);
                if ( ls.text_lines[j] == row && row.split('%').length-1 == 2 )
                    continue;
                text.push(row);
            }
            var round = ls.round_corner||0;

            var point = item.geometry.coordinates;
            var m = _getLabelMetrics(text, font_size, padding);
            if ( min_width && m.w < min_width )
                m.w = min_width;
            for ( var j = 0 ; j < position.length ; j++ ) {
                var angle = position[j][1];
                var dist = position[j][0];
                var o = _rotate(dist, angle);  
                var ox, oy;
                var lx = ox = o[0];
                var ly = oy = o[1];
                var a = (angle+360)%360;
                if ( a == 0 || a == 180 )
                    ox -= m.w/2;
                else if ( a > 180 )
                    ox -= m.w;
                if ( 270 <= a || a < 90 )
                    oy -= m.h-font_size*2;
                var sx = ox;
                var ex = ox+m.w;
                var sy = oy-font_size;
                var ey = m.h+oy-font_size+padding.bottom;
                var ww = ex-sx, hh = ey-sy;
                if ( !mask.intersectRect(point, sx, sy, ww, hh) ) {
                      labels.push({
                        text:text, point:point, lx:lx, ly:ly, ox:ox, oy:oy, sx:sx, ex:ex, sy:sy, ey:ey, round:round, geo:item
                    });
                    mask.addRect(point, sx, sy, ww, hh, margin);
                    mask.addRect(point, px, py, pw, ph);
                    break;
                }
            }
        }
    }

    function labelOutline(sx, sy, ex, ey, r) {
        var w = ex-sx;
        var h = ey-sy;
        if ( r*2 > w )
            r = w/2;
        if ( r*2 > h )
            r = h/2;
        var step = 6;
        var a = 0;
        var d = 90/step;
        var outline = [];
        outline.push([sx+r, sy]);
        if ( r ) {
            outline.push([ex-r, sy]);
            for ( var i = 0 ; i < step-1 ; i++ ) {
                a += d;
                var p = _rotate(r, a)
                outline.push([p[0]+ex-r, p[1]+sy+r]);
            }
            a += d;
        }
        outline.push([ex, sy+r]);
        if ( r ) {
            outline.push([ex, ey-r]);
            for ( var i = 0 ; i < step-1 ; i++ ) {
                a += d;
                var p = _rotate(r, a)
                outline.push([p[0]+ex-r, p[1]+ey-r]);
            }
            a += d;
        }
        outline.push([ex-r, ey]);
        if ( r ) {
            outline.push([sx+r, ey]);
            for ( var i = 0 ; i < step-1 ; i++ ) {
                a += d;
                var p = _rotate(r, a)
                outline.push([p[0]+sx+r, p[1]+ey-r]);
            }
            a += d;
        }
        outline.push([sx, ey-r]);
        if ( r ) {
            outline.push([sx, sy+r]);
            for ( var i = 0 ; i < step-1 ; i++ ) {
                a += d;
                var p = _rotate(r, a)
                outline.push([p[0]+sx+r, p[1]+sy+r]);
            }
        }
        outline.push([sx+r, sy]);
        return outline;
    }

    this.draw = function(layer, content, conf, context, style, data, revision, dl) {
        WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

        //リビジョン & 言語 & timezone 変化チェックを追加
        var noChange = true;
        if ( this.content_revision !== revision.content) {
            noChange = false;
        } else if (this.context_revision !== revision.context) {
            noChange = false;
        } else if (this.conf_revision !== revision.conf) {
            noChange = false;
        } else if (this.style_revision !== revision.style) {
            noChange = false;
        } else if (this.data_revision !== revision.data) {
            noChange = false
        } else if (this.locale !== WRAP.Core.locale) {
            noChange = false
        } else if (this.timeZone !== WRAP.Core.timezone) {
            noChange = false
        }

        if (noChange) {
            return
        }

        layer.setStatus({status:"invalid"});
        
        prepareOverlay(data, layer);

        var root = data.retained.data;
        if ( !root ) {
            if ( data.status.data && data.status.data != 'completed' )
                layer.setStatus({status:"error", reason:data.status.data});
            return;
        }
        
        layer.clear();

        var features;
        if (conf.Attributes.filter) {
            features = [];
            for ( var idx = 0 ; idx < root.features.length ; idx++ ) {
                var pt = root.features[idx];
                if (conf.Attributes.filter(pt, idx, root.features)) {
                    features.push(pt);
                }
            }
        } else {
            features  = root.features;
        }

        var locale = WRAP.Core.locale;
        if (locale != 'ja')
            locale = 'en';
        var size = WRAP.Geo.getSize();
        var ps = conf.Attributes.point;
        var ls = conf.Attributes.label;
        var fs = conf.Attributes.popup;
        var cs = conf.Attributes.custom;
        var key = conf.Attributes.key||'id';

        var selection_label;
        if ( conf.Attributes.selection_label ) {
            selection_label = {
                key:conf.Attributes.selection_label.key,
                font_size:conf.Attributes.selection_label.font_size||12,
                text_color:conf.Attributes.selection_label.text_color||'black',
                text_edge_color:conf.Attributes.selection_label.text_edge_color
            };
            if ( conf.Attributes.selection_label.position ) {
                selection_label.ox = conf.Attributes.selection_label.position[0];
                selection_label.oy = conf.Attributes.selection_label.position[1];
            }
            else {
                selection_label.ox = selection_label.oy = 0;
            }
            if ( selection_label.ox == 0 )
                selection_label.align = 'center';
            else if ( selection_label.ox < 0 )
                selection_label.align = 'right';
            else
                selection_label.align = 'left';
        }

        var labels = [];

        if ( !conf.Attributes.selection ) {
            var point_mask, mx, my, mw, mh;
            if ( ps.mask_size ) {
                point_mask = WRAP.Geo.getMask();
                point_mask.clear(0.1);
                mx = my = -ps.mask_size/2;
                mw = mh = ps.mask_size;
            }

            var points = [];
            for ( var i = 0 ; i < features.length ; i++ ) {
                var item = features[i];
                var point = item.geometry.coordinates;

                var sp = WRAP.Geo.getScreenPoint(new WRAP.Geo.Point(point[1]*60, point[0]*60));
                if ( sp.x < 0 || size.width <= sp.x || sp.y < 0 || size.height <= sp.y ) 
                    continue;
                if ( point_mask ) {
                    if ( point_mask.intersectRect(point, mx, my, mw, mh) )
                        continue;
                        point_mask.addRect(point, mx, my, mw, mh)
                }
                points.push(item);
            }

            var px = -ps.mask_size/2;
            var py = -ps.mask_size/2;
            var pw = ps.mask_size;
            var ph = ps.mask_size;
            var font_size = ls.font_size||10;
            var p = ls.padding!==undefined?ls.padding:1;
            var padding = {
                line:p,
                left:ls.padding_left!==undefined?ls.padding_left:1,
                right:ls.padding_right!==undefined?ls.padding_right:1,
                top:ls.padding_top!==undefined?ls.padding_top:1,
                bottom:ls.padding_bottom!==undefined?ls.padding_bottom:1
            }
            var margin = ls.margin||0;
            var position = ls.position||[[10,45]];
            var min_width = ls.min_width;
            var mask = WRAP.Geo.getMask();
            mask.clear(0.1);
            _addLabels(labels, mask, points, ls, cs, locale, font_size, px, py, pw, ph, padding, margin, position, min_width, true);
            if ( !ls.prioritize_zoom || ls.prioritize_zoom <= context.zoom ) {
                if (ls.prioritize_max_point && points.length < ls.prioritize_max_point)
                    _addLabels(labels, mask, points, ls, cs, locale, font_size, px, py, pw, ph, padding, margin, position, min_width, false);
            }

            // draw un-prioritized in data order
            for (var i = 0 ; i < points.length ; i++) {
                var item = points[i];
                var prop = item.properties;
                if (prop.prioritized)
                    continue;
                var point = item.geometry.coordinates;
                var feature = new WRAP.Geo.Feature.Point({
                    point:point,
                    strokeStyle:ps.line_color,
                    lineWidth:ps.line_width,
                    //fillStyle:ps.color,
                    fillStyle:this.resolve(prop,ps.color),
                    pointSize:ps.size,
                    sensorSize:ps.sensor_size,
                    blink:ps.blink
                });
                feature.geo = item;
                layer.addFeature(feature);
            }

            // draw prioritized 
            for (var i = points.length-1 ; i >= 0  ; i--) {
                var item = points[i];
                var prop = item.properties;
                if (!prop.prioritized)
                    continue;
                var point = item.geometry.coordinates;
                var feature = new WRAP.Geo.Feature.Point({
                    point:point,
                    strokeStyle:ps.line_color,
                    lineWidth:ps.line_width,
                    fillStyle:this.resolve(prop,ps.color),
                    pointSize:ps.size,
                    sensorSize:ps.sensor_size,
                    blink:ps.blink
                });
                feature.geo = item;
                layer.addFeature(feature);
            }

            // draw label
            var text_color = ls.text_color||'black';
            var line_color = ls.line_color||'black';
            var fill_color = ls.fill_color||'white';
            var line_width = ls.line_width||1;
            var edge_color = ls.edge_color||'white';
            var edge_width = ls.edge_width||1;
            for ( var i = 0 ; i < labels.length ; i++ ) {
                var l = labels[i];
                layer.addFeature(new WRAP.Geo.Feature.Line({
                    point:l.point,
                    line:[[0,0], [l.lx,l.ly]],
                    strokeStyle:line_color,
                    lineWidth: line_width
                }));
                layer.addFeature(new WRAP.Geo.Feature.Point({
                    point:l.point,
                    strokeStyle:line_color,
                    lineWidth:line_width,
                    pointSize:ps.size+line_width,
                }));
                var feature = new WRAP.Geo.Feature.Point({
                    point:l.point,
                    strokeStyle:ps.line_color,
                    lineWidth:ps.line_width,
                    fillStyle:this.resolve(l.geo.properties, ls.point_color||ps.color),
                    pointSize:ps.size,
                    sensorSize:ps.sensor_size,
                });
                feature.geo = l.geo;
                layer.addFeature(feature);
            }
        }

        if ( overlay ) {
            if ( overlay.current_feature ) {
                for ( var j = 0 ; j < features.length ; j++ ) { // update tooltip
                    var item = features[j];
                    if ( item.properties[overlay.key] == overlay.current_feature.geo.properties[overlay.key] ) {
                        overlay.current_feature.geo = item;
                        overlay.tooltip_content.innerHTML = makeContent(overlay.conf.tooltip.text_lines, overlay.current_feature.geo.properties);
                        break;
                    }
                }
            }

            for (var i = 0 ; i < overlay.popup.length ; i++) {
                var popup = overlay.popup[i];
                for ( var j = 0 ; j < features.length ; j++ ) { // update popup
                    var item = features[j];
                    if ( item.properties[overlay.key] == popup.id ) {
                        popup.point = item.geometry.coordinates;
                        popup.prop = item.properties;
                        break;
                    }
                }

                var feature = new WRAP.Geo.Feature.Point({
                    point:popup.point,
                    fillStyle:this.resolve(popup.prop,fs.point_color||ps.color),
                    strokeStyle:conf.Attributes.selection?ps.line_color:undefined,
                    lineWidth:ps.line_width,
                    pointSize:ps.size,
                });
                layer.addFeature(feature);

                 if ( conf.Attributes.selection && selection_label ) {
                    var key = selection_label.key;
                    var text = popup.prop[key];
                    if ( key == 'LNAME' && locale == 'en' && popup.prop.ENAME )
                        text = popup.prop.ENAME;
                    if ( !text )
                        continue;
                    feature = new WRAP.Geo.Feature.Text({
                        point:popup.point,
                        text:text,
                        fontSize:selection_label.font_size,
                        fillStyle:selection_label.text_color,
                        strokeStyle:selection_label.text_edge_color,
                        offsetX:selection_label.ox,
                        offsetY:selection_label.oy,
                        align:selection_label.align
                    });
                    layer.addFeature(feature);
                 }
            }

            //draw popup
            if (conf.Attributes.popup.popup_link) {
                points.forEach(item => {
                    const prop = item.properties;
                    if (prop.popup === true) {
                        if (!findWindow(prop[conf.Attributes.key])) {
                            createWindow(item);
                        }
                    }
                });
            }
        }

        for ( var i = 0 ; i < labels.length ; i++ ) {
            var l = labels[i];
            var outline = labelOutline(l.sx, l.sy, l.ex, l.ey, l.round);
            var feature = new WRAP.Geo.Feature.Line({
                point: l.point,
                line:outline,
                fillStyle: fill_color,
                strokeStyle: this.resolve(l.geo.properties, edge_color),
                lineWidth: edge_width
            });
            layer.addFeature(feature);
            feature = new WRAP.Geo.Feature.Text({
                point:l.point,
                text:l.text,
                fontSize:font_size,
                fillStyle:text_color,
                offsetX:l.ox+padding.left,
                offsetY:l.oy+padding.top,
                align:'left',
                lineSpacing:padding.line
            });
            layer.addFeature(feature);
            var feature = new WRAP.Geo.Feature.Line({
                point: l.point,
                line:outline,
                fillStyle: 'rgba(0,0,0,0.01)'
            });
            feature.data = {
                type:"label",
                id:l.geo.properties[key],
                geo:l.geo,
                point:l.point,
                sx:l.sx, sy:l.sy, ex:l.ex, ey:l.ey
            }
            layer.addFeature(feature);
        }

        this.content_revision = revision.content;
        this.context_revision = revision.context;
        this.conf_revision = revision.conf;
        this.style_revision = revision.style;
        this.data_revision = revision.data;
        this.locale = locale;
        this.timeZone = WRAP.Core.timezone;

        if ( layer.getStatus().status != 'error' )
            layer.setStatus({status:"valid"});
        WRAP.Geo.invalidate();

        if ( conf.Attributes.tooltip || conf.Attributes.popup )
            updateOverlay(data, layer, conf, locale);
    }

    this.clear = function(layer) {
        for ( var e in overlay.listner )
            overlay.interaction.block.removeEventListener(e, overlay.listner[e]);
        for ( var e in overlay.handler )
            WRAP.Geo.removeEventHandler(e, overlay.handler[e]);
        clearOverlay(layer);
        if ( overlay.block && overlay.block.parentNode == overlay.interaction.block )
            overlay.interaction.block.removeChild(overlay.block);

    }

    var overlay;

    function clearOverlay(layer) {
        var last_overlay = layer.overlay_block;
        if ( last_overlay ) {
            if ( last_overlay.parentNode )
                last_overlay.parentNode.removeChild(last_overlay);
            layer.overlay_block = null;
        }
        overlay = undefined;                
    }

    function prepareOverlay(data, layer) {
        if ( layer.overlay_data != data ) {
            layer.overlay_data = data;
            clearOverlay(layer);
        }
    }

    function updateOverlay(data, layer, conf, locale) {
        if ( !overlay )
            layer.overlay_block = initOverlay(layer);
        overlay.conf = conf.Attributes;
        overlay.key = conf.Attributes.key||'id';
        overlay.locale = locale;
        // makeIcon(overlay.tooltip_button, overlay.conf.open_button, overlay.conf.open_button_hover, overlay.conf.open_button_active);
        // overlay.tooltip_button.style.position = 'absolute';
        // overlay.tooltip_button.style.top = (overlay.conf.padding_button||1)+'px';
        // overlay.tooltip_button.style.right = (overlay.conf.padding_button||1)+'px';
        makeIcon(overlay.label_button, overlay.conf.open_button, overlay.conf.open_button_hover, overlay.conf.open_button_active);
        if ( conf.Attributes.selection_label )
            overlay.label_button.style.display = 'none';
        updateWindow();
    }

    function initOverlay(layer) {
        overlay = {
            layer:layer,
            // html
            interaction:layer.view.interaction, // map div
            block:null,
            tooltip:null,
            tooltip_content:null,
            // tooltip_button:null,
            label_button:null,
            // operation target 
            pointer:[-9000,-9000],
            dragging:false,
            drag:[0,0],
            offset:[0,0],
            current_feature:null,
            current_tooltip:null,
            tooltip_range:[],
            current_label:null,
            // fixed popups
            popup:[],
            popup_index:WRAP.Configuration.overlay.z.point_info_popup,
            tooltip_index:WRAP.Configuration.overlay.z.point_info_tooltip,
        };

        overlay.interaction.block.addEventListener('mousedown', function(event) {
            if (!overlay.layer.visible() || !overlay.current_tooltip) {
                return;
            }
            const mouseDownX = event.clientX;
            const mouseDownY = event.clientY;
            const mouseupHandle = function(ev) {
                overlay.interaction.block.removeEventListener('mouseup', mouseupHandle);
                const mouseUpX = ev.clientX;
                const mouseUpY = ev.clientY;
                const dist = Math.sqrt( Math.pow( mouseUpX-mouseDownX, 2 ) + Math.pow( mouseUpY-mouseDownY, 2 ) );
                //mousedown時とmouseup時のスクリーン座標が10ピクセルより離れていたらクリックではなくドラッグとみなして何もしない
                if (dist > 10) {
                    return;
                }
                if ( overlay.current_tooltip && overlay.current_tooltip.geo && !findWindow(overlay.current_tooltip.geo.properties[overlay.key]) ) {
                    overlay.layer.overlay_data.controller.setSelectedPopup(overlay.layer.overlay_data, overlay.current_tooltip.geo.properties[overlay.key], true);
                    createWindow(overlay.current_tooltip.geo);
                    hideTooltip();
                }
            };
            overlay.interaction.block.addEventListener('mouseup', mouseupHandle);
        });

        overlay.block = document.createElement('div');
        overlay.interaction.block.appendChild(overlay.block);

        overlay.tooltip = document.createElement('div');
        overlay.tooltip.style.zIndex = overlay.tooltip_index;
        overlay.tooltip.style.position = 'absolute';
        overlay.tooltip_content = document.createElement('div');
        overlay.tooltip.appendChild(overlay.tooltip_content);
        overlay.tooltip.style.display = 'none';

        // overlay.tooltip_button = new Image();
        // overlay.tooltip_button.onclick = function() {
        //     if ( !findWindow(overlay.current_tooltip.geo.properties[overlay.key]) ) {
        //         createWindow(overlay.current_tooltip.geo, [0,-20]);
        //         hideTooltip();
        //     }
        // }
        // overlay.tooltip.appendChild(overlay.tooltip_button);
        overlay.block.appendChild(overlay.tooltip);

        overlay.label_button = new Image();
        overlay.label_button.style.position = 'absolute';
        overlay.label_button.onclick = function() {
            var data = overlay.current_label.data;
            if ( !findWindow(data.id) ) {
                createWindow(data.geo, [data.sx,data.sy]);
                hideTooltip();
            }
        }
        overlay.label_button.style.display = 'none';
        overlay.block.appendChild(overlay.label_button);    

        overlay.listner = {
            mousemove: function(evt) {
                if ( !overlay )
                    return;
                var x, y;
                if ( evt.touches ) {
                    x = evt.touches[0].pageX;
                    y = evt.touches[0].pageY;
                }
                else {
                    x = evt.clientX;
                    y = evt.clientY;
                }
                if ( overlay.dragging ) {
                    // overlay.dragging.style.left = (x-overlay.offset[0]) + 'px';
                    // overlay.dragging.style.top = (y-overlay.offset[1]) + 'px';
                    for( let i = 0 ; i < overlay.dragging.length ; i ++ ) {
                        const elm = overlay.dragging[i];
                        elm.style.left = (x - overlay.offset[0]) + 'px';
                        elm.style.top = (y - overlay.offset[1]) + 'px';
                    }

                    hideTooltip();
                    //evt.preventDefault();
                }
                var sr = overlay.interaction.block.getBoundingClientRect();
                overlay.pointer[0] = x-sr.left;
                overlay.pointer[1] = y-sr.top;
                //console.log("point "+overlay.pointer[0]+","+overlay.pointer[1]+" offset "+ox+","+oy)            
                if ( !overlay.current_feature )
                    hideTooltip();
            },
            mouseleave: function(evt) {
                hideTooltip();
            }
        }
        for ( var e in overlay.listner )
            overlay.interaction.block.addEventListener(e, overlay.listner[e]);

        overlay.handler = {
            mouseover: function(layer, feature, pos) {
                if ( layer == overlay.layer && feature ) {
                    if ( feature.data && feature.data.type == 'label' ) {
                        if ( findWindow(feature.data.id) )
                            return;
                        overlay.current_label = feature;
                        updateCurrentLabel();
                        hideTooltip();
                    }
                    else if ( feature.geo ) {
                        overlay.current_feature = feature;
                        showTooltip(feature, pos);
                    }
                }
            },
            mouseout: function(layer, feature) {
                if ( layer == overlay.layer ) {
                    if ( layer == overlay.layer && feature ) {
                        if ( feature.data && feature.data.type == 'label' ) {
                            overlay.current_label = null;
                            updateCurrentLabel();
                        }
                    }
                    if ( feature.geo ) {
                        overlay.current_feature = null;
                        hideTooltip();
                    }
                }
            },
            boundsChange: function() {
                hideTooltip();
                var zoom = WRAP.Geo.getZoom();
                if ( overlay.zoom != zoom ) {
                    overlay.zoom = zoom;
                    overlay.current_label = null;
                }
                updateCurrentLabel();
            },
            visibilityChange: function() {
                if ( !overlay )
                    return;
                var d = overlay.layer.visible()?'block':'none';
                for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
                    var p = overlay.popup[i];
                    var w = p.element;
                    w.style.display = d;
                }
                hideTooltip();
            }
        }
        for ( var e in overlay.handler )
            WRAP.Geo.addEventHandler(e, overlay.handler[e]);
        return overlay.block;
    }

    function makeIcon(icon, def, hover, active) {
        if ( !hover )
            hover = def;
        if ( !active )
            active = hover;
        icon.src = def;
        icon.onmouseenter = function() {icon.src = hover}
        icon.onmouseout = function() {icon.src = def}
        icon.onmousedown = function() {icon.src = active}
        icon.onmouseup = function() {icon.src = hover}
    }

    function makeContent(rows, prop) {
        var text = "";
        for ( var i = 0 ; i < rows.length ; i++ ) {
            if (overlay.conf.contentFilter && !overlay.conf.contentFilter(rows[i], prop, i, rows)) {
                continue;
            }
            var row = _mapping(overlay.locale, rows[i], prop, overlay.conf.custom);
            if ( rows[i] == row && row.split('%').length-1 == 2 )
                continue;
            if ( text.length )
                text += '<br>';
            text+= row;
        }
        return text;
    }

    function showTooltip(feature, pos) {
        if ( findWindow(feature.geo.properties[overlay.key]) )
            return;
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
            var w = overlay.popup[i].element;
            if ( w.offsetLeft <= pos.x && pos.x < w.offsetLeft+w.offsetWidth
                && w.offsetTop <= pos.y && pos.y < w.offsetTop+w.offsetHeight)
                return;
        }
        var p = overlay.conf.tooltip.padding!==undefined?overlay.conf.tooltip.padding:4;
        var padding = {
            line:p,
            left:overlay.conf.tooltip.padding_left!==undefined?overlay.conf.tooltip.padding_left:p,
            right:overlay.conf.tooltip.padding_right!==undefined?overlay.conf.tooltip.padding_right:p,
            top:overlay.conf.tooltip.padding_top!==undefined?overlay.conf.tooltip.padding_top:p,
            bottom:overlay.conf.tooltip.padding_bottom!==undefined?overlay.conf.tooltip.padding_bottom:p,
        }
        overlay.tooltip_content.innerHTML = makeContent(overlay.conf.tooltip.text_lines, feature.geo.properties);
        overlay.tooltip.style.cursor = 'default';
        overlay.tooltip.style.userSelect = 'none';
        overlay.tooltip.style.webkitUserSelect = 'none';
        var fontsize = overlay.conf.tooltip.font_size||12;
        overlay.tooltip_content.style.fontSize = fontsize+'px';
        overlay.tooltip_content.style.lineHeight = padding.line+fontsize+'px'
        if ( overlay.conf.tooltip.width )
            overlay.tooltip.style.width = overlay.conf.tooltip.width+'px';
        overlay.tooltip.style.backgroundColor = overlay.conf.tooltip.fill_color;
        overlay.tooltip.style.color = overlay.conf.tooltip.text_color;
        overlay.tooltip.style.border = "" + overlay.conf.tooltip.line_width + 'px solid ' + overlay.conf.tooltip.line_color;
        overlay.tooltip.style.display = 'block';
        var sr = overlay.interaction.block.getBoundingClientRect();
        var x = pos.x + 10;
        var y = pos.y + 10;
        if (x+overlay.tooltip.clientWidth > sr.width) {
            x = pos.x - overlay.tooltip.clientWidth - 10;
        }
        if (y+overlay.tooltip.clientHeight > sr.height) {
            y = pos.y - overlay.tooltip.clientHeight - 10;
        }
        overlay.tooltip.style.left = x+'px';
        overlay.tooltip.style.top = y+'px';
        overlay.tooltip.style.paddingLeft = padding.left+'px';
        overlay.tooltip.style.paddingRight = padding.right+'px';
        overlay.tooltip.style.paddingTop = padding.top+'px';
        overlay.tooltip.style.paddingBottom = padding.bottom+'px';
        overlay.tooltip.style.borderRadius = (overlay.conf.tooltip.round_corner||0)+'px';

        overlay.tooltip_range = [x, y, x+overlay.tooltip.clientWidth, y+overlay.tooltip.clientHeight];
        overlay.current_tooltip = feature;
    }

    function hideTooltip() {
        if ( !overlay || !overlay.tooltip )
            return;
        overlay.tooltip_content.innerHTML = "";
        overlay.tooltip.style.display = 'none';
        overlay.current_tooltip = null;
    }

    function updateCurrentLabel() {
        if ( !overlay.current_label ) {
            if ( overlay.label_button.style.display != 'none' )
                overlay.label_button.style.display = 'none';
            return;
        }

        var p = overlay.current_label.data;
        if ( findWindow(p.id) )
            return;
        var button = overlay.label_button;
        var sps = WRAP.Geo.getScreenLine([p.point]);
        if ( !sps || !sps[0] )
            return;
        var sp;
        var nearest;
        var mx = (p.sx+p.ex)/2;
        var my = (p.sy+p.ey)/2;
        for ( var i = 0 ; i < sps.length ; i++ ) {
            var dx = sps[i][0].x+mx-overlay.pointer[0];
            var dy = sps[i][0].y+my-overlay.pointer[1];
            var d = dx*dx+dy*dy;
            if ( !sp || d < nearest ) {
                sp = sps[i][0];
                nearest = d;
            }
        }
        var padding_button = overlay.conf.padding_button||1;
        var x = sp.x+p.ex-padding_button-(button.width||20);
        var y = sp.y+p.sy+padding_button;
        button.style.display = 'block';
        if ( !inMap(x, y, button.clientWidth, button.clientHeight) ) {
            button.style.display = 'none';
            return;
        }
        button.style.left = x+'px';
        button.style.top = y+'px';
        button.style.display = 'block';
    }

    function inMap(x, y, w, h) {
        var size = WRAP.Geo.getSize();
        if ( x < 0 || x+w > size.width )
            return false;
        if ( y < 0 || y+h > size.height )
            return false;
        return true;
    }

    function createWindow(geo, offset) {
        var p = overlay.conf.popup.padding!==undefined?overlay.conf.popup.padding:4;
        var padding = {
            line:p,
            left:overlay.conf.popup.padding_left!==undefined?overlay.conf.popup.padding_left:p,
            right:overlay.conf.popup.padding_right!==undefined?overlay.conf.popup.padding_right:p,
            top:overlay.conf.popup.padding_top!==undefined?overlay.conf.popup.padding_top:p,
            bottom:overlay.conf.popup.padding_bottom!==undefined?overlay.conf.popup.padding_bottom:p,
        }
        //popup_linkがtrueで同一keyのwindowが作成済みの場合、表示位置と開閉状態を作成するwindowに引き継ぐ
        let sameKeyPopup = [];
        if (overlay.conf.popup.popup_link) {
            sameKeyPopup = document.getElementsByClassName(geo.properties[overlay.key]);
        }

        var w = document.createElement('div');
        w.detail = false;
        w.style.position = 'absolute';
        if ( overlay.conf.popup.width )
            w.style.width = overlay.conf.popup.width+'px';
        w.style.backgroundColor = overlay.conf.popup.fill_color;
        w.style.color = overlay.conf.popup.text_color;
        w.style.border = "" + overlay.conf.popup.line_width + 'px solid ' + renderer.resolve(geo.properties, overlay.conf.popup.line_color);
        w.style.paddingLeft = padding.left+'px';
        w.style.paddingRight = padding.right+'px';
        w.style.paddingTop = padding.top+'px';
        w.style.paddingBottom = padding.bottom+'px';
        w.style.borderRadius = (overlay.conf.popup.round_corner||0)+'px';
        w.classList.add(geo.properties[overlay.key])

        var contentArea = document.createElement('div');
        w.contentArea = contentArea;
        var fontsize = overlay.conf.popup.font_size||12;
        w.contentArea.style.fontSize = fontsize+'px';
        w.contentArea.style.lineHeight = padding.line+fontsize+'px'

        w.appendChild(contentArea);
        // contentArea.innerHTML = makeContent(overlay.conf.popup.text_lines, geo.properties);
        if (sameKeyPopup.length !== 0 && sameKeyPopup[0].detail === true) {
            //同一keyの開いた状態を引き継ぐ
            w.detail = true;
            contentArea.innerHTML = makeContent(overlay.conf.popup.extended_text_lines, geo.properties);
        } else {
            contentArea.innerHTML = makeContent(overlay.conf.popup.text_lines, geo.properties);
        }

        var iconArea = document.createElement('div');
        iconArea.style.position = 'absolute';
        iconArea.style.textAlign = 'right';
        iconArea.style.padding = overlay.conf.padding_button+'px';
        iconArea.style.top = '0px';
        iconArea.style.bottom = '0px';
        iconArea.style.left = '0px';
        iconArea.style.right = '0px';
        iconArea.style.fontSize = '12px';
        w.appendChild(iconArea);

        var unfix_button = new Image();
        makeIcon(unfix_button, overlay.conf.close_button, overlay.conf.close_button_hover, overlay.conf.close_button_active);
        unfix_button.addEventListener('mousedown', function(e) {
            hideTooltip();
            overlay.dragging = null;
            e.stopPropagation();
        });
        unfix_button.onclick = function(ev) {
            overlay.layer.overlay_data.controller.setSelectedPopup(overlay.layer.overlay_data, geo.properties[overlay.key], false);
            hideTooltip();
            deleteWindow(w);
            //同一keyのclickを発火させる
            if (sameKeyPopup.length !== 0 && ev.isTrusted) {
                const thisParent = this.parentElement.parentElement;
                while (sameKeyPopup.length !== 0) {
                    const parent = sameKeyPopup[0];
                    if (thisParent !== parent) {
                        const bt = parent.getElementsByTagName('img')[1];
                        bt.click();
                    }
                }
            }
        }
        var detail_button = new Image();
        // makeIcon(detail_button, overlay.conf.detail_button, overlay.conf.detail_button_hover, overlay.conf.detail_button_active);
        if (sameKeyPopup.length !== 0 && sameKeyPopup[0].detail === true) {
            //同一keyの開いた状態を引き継ぐ
            makeIcon(detail_button, overlay.conf.simple_button, overlay.conf.simple_button_hover, overlay.conf.simple_button_active);
        } else {
            makeIcon(detail_button, overlay.conf.detail_button, overlay.conf.detail_button_hover, overlay.conf.detail_button_active);
        }
        detail_button.style.marginRight = overlay.conf.padding_button+'px';
        detail_button.addEventListener('mousedown', function(e) {
            hideTooltip();
            overlay.dragging = null;
            activateWindow(w);
            e.stopPropagation();
        });
        detail_button.onclick = function(ev) {
            hideTooltip();
            var prop;
            for (var i = 0; i < overlay.popup.length; i++) {
                if (overlay.popup[i].element === w) {
                    prop = overlay.popup[i].prop;
                    break;
                }
            }
            if ( w.detail == true ) {
                w.detail = false;
                makeIcon(detail_button, overlay.conf.detail_button, overlay.conf.detail_button_hover, overlay.conf.detail_button_active);
                contentArea.innerHTML = makeContent(overlay.conf.popup.text_lines, prop);
            }
            else {
                w.detail = true;
                makeIcon(detail_button, overlay.conf.simple_button, overlay.conf.simple_button_hover, overlay.conf.simple_button_active);
                contentArea.innerHTML = makeContent(overlay.conf.popup.extended_text_lines, prop);
            }
            //同一keyのclickを発火させる
            if (sameKeyPopup.length > 1 && ev.isTrusted) {
                const thisParent = this.parentElement.parentElement;
                for (let i = 0; i < sameKeyPopup.length; i++) {
                    const parent = sameKeyPopup[i]
                    if (thisParent !== parent) {
                        const bt = parent.getElementsByTagName('img')[0];
                        bt.click();
                    }
                }
            }
        }
        iconArea.appendChild(detail_button);
        iconArea.appendChild(unfix_button);

        w.addEventListener('mousedown', function(evt) {
            // overlay.dragging = this;
            overlay.dragging = document.getElementsByClassName(this.className);
            overlay.drag[0] = w.style.left.replace(/px/, "");
            overlay.drag[1] = w.style.top.replace(/px/, "");
            overlay.offset[0] = evt.clientX-overlay.drag[0];
            overlay.offset[1] = evt.clientY-overlay.drag[1];
            activateWindow(w);
        });
        w.addEventListener('mouseup', function() {
            overlay.dragging = null;
        });
        w.addEventListener('touchstart', function(evt) {
            if ( evt.touches && evt.touches.length == 1 ) {
                overlay.dragging = this;
                overlay.drag[0] = w.style.left.replace(/px/, "");
                overlay.drag[1] = w.style.top.replace(/px/, "");
                overlay.offset[0] = evt.touches[0].pageX-overlay.drag[0];
                overlay.offset[1] = evt.touches[0].pageY-overlay.drag[1];
                activateWindow(w);
            }
        });
        w.addEventListener('touchend', function() {
            overlya.dragging = null;
        });
        var sameKeyPopupStyle;
        if (sameKeyPopup.length !== 0 ) {
            sameKeyPopupStyle = sameKeyPopup[0].style;
        }
        overlay.block.appendChild(w);
        var sr = overlay.interaction.block.getBoundingClientRect();
        var sp = WRAP.Geo.getScreenPoint(convertWRAPPoint(geo.geometry.coordinates[1], geo.geometry.coordinates[0]));
        if (sameKeyPopupStyle) {
            //同一keyの表示位置を引き継ぐ
            w.style.left = sameKeyPopupStyle.left;
            w.style.top = sameKeyPopupStyle.top;
        } else {
            var x = offset ? sp.x+offset[0] : sp.x + 10;
            var y = offset ? sp.y+offset[1] : sp.y + 10;
            if (x+w.clientWidth > sr.width) {
                x = sp.x - w.clientWidth - 10;
            }
            if (y+w.clientHeight > sr.height) {
                y = sp.y - w.clientHeight - 10;
            }
            w.style.left = x+'px';
            w.style.top = y+'px';
        }
        overlay.popup.push({id:geo.properties[overlay.key], point:geo.geometry.coordinates, prop:geo.properties, element:w});
        WRAP.Geo.redraw(overlay.layer);
        activateWindow(w);
    }

    function findWindow(id) {
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
            if ( overlay.popup[i].id == id )
                return overlay.popup[i].element;
        }
    }

    function activateWindow(w) {
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
            if ( overlay.popup[i].element == w ) {
                var p = overlay.popup[i];
                overlay.popup.splice(i, 1);
                overlay.popup.push(p);
                while ( i < overlay.popup.length ) {
                    overlay.popup[i].element.style.zIndex = overlay.popup_index+i;
                    i++;
                }
                return;                    
            }
        }
    }

    function updateWindow() {
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
            var p = overlay.popup[i];
            var w = p.element;
            w.style.border = "" + overlay.conf.popup.line_width + 'px solid ' + renderer.resolve(p.prop, overlay.conf.popup.line_color);
            w.contentArea.innerHTML = makeContent(overlay.conf.popup[w.detail?'extended_text_lines':'text_lines'], p.prop);
        }
    }

    function deleteWindow(w) {
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
            if ( overlay.popup[i].element == w ) {
                overlay.popup.splice(i, 1);
                overlay.block.removeChild(w);
                WRAP.Geo.redraw(overlay.layer);
                return;
            }
        }
    }
}
/* eslint-enable */
